// https://github.com/debitoor/dot-prop-immutable
import initialState from './initialState'

import {
  SET_CURRENT_PRESET,
  SET_PRESET_GAIN,
  SET_GAP_CAPS, SET_GAP_CAPS_CURVE, SET_GAP_CAPS_CHANNEL, TOGGLE_GAP_CAPS,
  SET_ZONE_CURVE, SET_ZONE_SPLIT_POINT, SET_ZONE_CHANNEL,
  DECREMENT_OCTAVE, INCREMENT_OCTAVE,
  DECREMENT_LOWNOTE, INCREMENT_LOWNOTE,
  SET_BUTTON_CHANNEL, SET_BUTTON_PROGRAM_CHANGE, SET_BUTTON_BANK_SELECT, SET_BUTTON_NOTE, SET_BUTTON_CC,
  SET_FADER_MODE, SET_FADER_CC, SET_FADER_CHANNEL,
  SET_PEDAL_MODE, SET_PEDAL_CC, SET_PEDAL_CHANNEL,
  SELECT_PLAY_MODE, SET_MIDI_NOTE_LENGTH, SET_DAMP_THRESHOLD,
 } from '../actions/actionTypes'

export default function currentPresetReducer(state = initialState.currentPreset, action) {
  switch (action.type) {
    case SET_CURRENT_PRESET:
      return { ...action.preset }
    // gapCaps
    case SET_GAP_CAPS: {
      return {
        ...state,
        gapCaps: {
           ...state.gapCaps,
           notes: [
             ...action.notes.slice(0, action.index),
             action.note,
             ...action.notes.slice(action.index + 1)
           ]
         }
       }
    }
    case SET_GAP_CAPS_CURVE: {
      return { ...state, gapCaps: { ...state.gapCaps, curve: action.curve } }
    }
    case SET_GAP_CAPS_CHANNEL: {
      return { ...state, gapCaps: { ...state.gapCaps, channel: action.channel } }
    }
    case TOGGLE_GAP_CAPS: {
      return {
        ...state,
        gapCaps: {
          ...state.gapCaps,
          notes: action.notes ? action.notes : [-1, -1, -1, -1, -1, -1]
        }
      }
    }
    // bars: splits
    case SET_ZONE_SPLIT_POINT: {
      return {
        ...state,
        splits: state.splits.slice(0, action.zone)
        .concat([{
          ...state.splits[action.zone],
          bar: action.bar
        }])
        .concat(state.splits.slice(action.zone + 1))
      }
    }
    case SET_ZONE_CURVE: {
      return {
        ...state,
        splits: state.splits.slice(0, action.zone)
        .concat([{
          ...state.splits[action.zone],
          curve: action.curve
        }])
        .concat(state.splits.slice(action.zone + 1))
      }
    }
    case SET_ZONE_CHANNEL: {
      return {
        ...state,
        splits: state.splits.slice(0, action.zone)
        .concat([{
          ...state.splits[action.zone],
          channel: action.channel
        }])
        .concat(state.splits.slice(action.zone + 1))
      }
    }
    // bars: octaves & lownotes
    case DECREMENT_OCTAVE: {
      let octave = (state.octave === -2) ? state.octave : state.octave - 1
      return { ...state, octave: octave }
    }
    case INCREMENT_OCTAVE:{
      let octave = (state.octave === 2) ? state.octave : state.octave + 1
      return { ...state, octave: octave }
    }
    case DECREMENT_LOWNOTE: {
      let lowNote = (state.lowNote === 0) ? state.lowNote : state.lowNote - 1
      return { ...state, lowNote: lowNote }
    }
    case INCREMENT_LOWNOTE: {
      let lowNote = (state.lowNote === 6) ? state.lowNote : state.lowNote + 1
      return { ...state, lowNote: lowNote }
    }
    // buttons
    case SET_BUTTON_CHANNEL: {
      return {
        ...state,
        buttons: state.buttons.slice(0, action.index)
        .concat([{...state.buttons[action.index], channel: action.channel}])
        .concat(state.buttons.slice(action.index + 1))
      }
    }
    case SET_BUTTON_PROGRAM_CHANGE: {
      return {
        ...state,
        buttons: state.buttons.slice(0, action.index)
        .concat([{...state.buttons[action.index], patch: action.patch}])
        .concat(state.buttons.slice(action.index + 1))
      }
    }
    case SET_BUTTON_BANK_SELECT: {
      return {
        ...state,
        buttons: state.buttons.slice(0, action.index)
        .concat([{...state.buttons[action.index], bankMSB: action.bankMSB, bankLSB: action.bankLSB}])
        .concat(state.buttons.slice(action.index + 1))
      }
    }
    case SET_BUTTON_NOTE: {
      return {
        ...state,
        buttons: state.buttons.slice(0, action.index)
        .concat([{...state.buttons[action.index], note: action.note}])
        .concat(state.buttons.slice(action.index + 1))
      }
    }
    case SET_BUTTON_CC: {
      return {
        ...state, buttons: state.buttons.slice(0, action.index)
        .concat([{...state.buttons[action.index], cc: action.cc}])
        .concat(state.buttons.slice(action.index + 1))
      }
    }
    // playability
    case SET_PRESET_GAIN: {
      return { ...state, gain: action.gain }
    }
    case SELECT_PLAY_MODE: {
      return { ...state, playParams: { ...state.playParams, playMode: ~~action.mode }}
    }
    case SET_MIDI_NOTE_LENGTH: {
      return { ...state, playParams: { ...state.playParams, noteOnTime: ~~action.length }}
    }
    case SET_DAMP_THRESHOLD: {
      return { ...state, playParams: { ...state.playParams, dampThreshold: ~~action.threshold }}
    }
    // faders
    case SET_FADER_MODE: {
      return {
        ...state,
        faders: state.faders.slice(0, action.index)
        .concat([{...state.faders[action.index], mode: action.mode}])
        .concat(state.faders.slice(action.index + 1))
      }
    }
    case SET_FADER_CC: {
      return {
        ...state,
        faders: state.faders.slice(0, action.index)
        .concat([{...state.faders[action.index], cc: action.cc}])
        .concat(state.faders.slice(action.index + 1))
      }
    }
    case SET_FADER_CHANNEL: {
      return {
        ...state,
        faders: state.faders.slice(0, action.index)
        .concat([{...state.faders[action.index], channel: action.channel}])
        .concat(state.faders.slice(action.index + 1))
      }
    }
    // pedals
    case SET_PEDAL_MODE: {
      return {
        ...state,
        pedals: state.pedals.slice(0, action.index)
        .concat([{...state.pedals[action.index], mode: action.mode}])
        .concat(state.pedals.slice(action.index + 1))
      }
    }
    case SET_PEDAL_CC: {
      return {
        ...state,
        pedals: state.pedals.slice(0, action.index)
        .concat([{...state.pedals[action.index], cc: action.cc}])
        .concat(state.pedals.slice(action.index + 1))
      }
    }
    case SET_PEDAL_CHANNEL: {
      return {
        ...state,
        pedals: state.pedals.slice(0, action.index)
        .concat([{...state.pedals[action.index], channel: action.channel}])
        .concat(state.pedals.slice(action.index + 1))
      }
    }

    default:
      return state
  }
}
